import { PAYMENT } from "../constants";

const now = new Date();

const initialState = {
  payments: [],
  total: 0,
  totals: [],
  limit: 20,
  offset: 0,
  month: now.getMonth() + 1,
  year: now.getFullYear(),
  moduleFilter: null,
  isLoadingGetPayments: false,
  error: null,
};

const paymentsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case PAYMENT.GET_PAYMENTS:
      return {
        ...state,
        isLoadingGetPayments: true,
      };
    case PAYMENT.GET_PAYMENTS_FAILURE:
      return {
        ...state,
        isLoadingGetPayments: false,
        error: action.payload,
      };
    case PAYMENT.GET_PAYMENTS_SUCCESS:
      return {
        ...state,
        isLoadingGetPayments: false,
        payments: action.payload.data,
        total: action.payload.total,
        totals: action.payload.totals,
        error: null,
      };
    case PAYMENT.SET_OFFSET:
      return {
        ...state,
        offset: action.payload,
      };
    case PAYMENT.SET_MONTH_YEAR:
      return {
        ...state,
        month: action.payload.month,
        year: action.payload.year,
        offset: 0,
      };
    case PAYMENT.SET_MODULE_FILTER:
      return {
        ...state,
        moduleFilter: action.payload,
        offset: 0,
      };
    default:
      return state;
  }
};

export default paymentsReducer;
